/*
 * File Created: Thursday, 1st June 2023 10:30:06 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from "@mui/material/Box";
import React from "react";
import { Colors } from "../../constants/color";
import { Image } from "../../types/static/StaticModal.type";

function ImagePreview({ images }: { images: Array<Image> }): JSX.Element {
  const [isView, setIsView] = React.useState(images[0]);

  function getClickedImage(id: string) {
    let image = images.find((imageId) => imageId.id === id);
    if (image !== undefined) {
      setIsView(image);
    }
  }

  const smallImage = images.map((image) => {
    return (
      <Box
        key={image.id}
        component="img"
        src={image.src}
        alt={image.type}
        onClick={() => getClickedImage(image.id)}
        sx={{
          objectFit: "cover",
          width: { xs: "80px", md: "100%" },
          height: { xs: "80px", sm: "116px", md: "120px", lg: "142px" },
          cursor: "pointer",
          border: isView.id === image.id ? `1px solid ${Colors.fallow}` : "none",
          filter: isView.id !== image.id ? "blur(1px)" : "0",
        }}
      />
    );
  });

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "50%", xl: "600px" },
        height: "100%",
        // backgroundColor: "greenyellow",
        display: "flex",
        flexDirection: { xs: "column-reverse", md: "row" },
        justifyContent: "space-between",
        gap: { xs: 1 },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "90px", lg: "115px" },
          height: "auto",
          maxHeight: { xs: "auto", lg: "611px", xl: "618px" },
          overflow: "auto",
          // backgroundColor: "indigo",
          display: "flex",
          gap: 1,
          flexDirection: { xs: "row", md: "column" },
        }}
      >
        {smallImage}
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "calc(100% - 95px)" },
          maxHeight: {
            xs: "463px",
            sm: "496px",
            md: "522px",
            lg: "611px",
            xl: "618px",
          },
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={isView.src}
          alt={isView.type}
          sx={{
            width: { xs: "100%" },
            height: { xs: "100%" },
            objectFit: "cover",
            objectPosition: "bottom",
            cursor: "move",
          }}
        />
      </Box>
      
    </Box>
  );
}

export default ImagePreview;
